import { render, staticRenderFns } from "./inputMedicaments.vue?vue&type=template&id=2593b884&"
import script from "./inputMedicaments.vue?vue&type=script&lang=js&"
export * from "./inputMedicaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports